import {
  collection,
  getDocs,
  doc,
  getDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
} from "firebase/firestore";

import { db } from "../../../firebase";

/* ==========================================
    GET ALL COUPONS
========================================== */

export async function getCoupons() {

  try {

    const snapshot = await getDocs(
      collection(db, "couponCodes")
    );

    return snapshot.docs.map((doc) => ({

      documentId: doc.id,

      ...doc.data(),

    }));

  } catch (error) {

    console.error(
      "Coupon Error:",
      error
    );

    return [];

  }

}
/* ==========================================
    GET SINGLE COUPON
========================================== */

export async function getCoupon(id) {

  try {

    const snapshot =
      await getDoc(
        doc(
          db,
          "couponCodes",
          id
        )
      );

    if (!snapshot.exists()) {

      return null;

    }

    return {

      documentId:
        snapshot.id,

      ...snapshot.data(),

    };

  } catch (error) {

    console.error(error);

    return null;

  }

}

/* ==========================================
    UPDATE COUPON
========================================== */

export async function updateCoupon(
  id,
  data,
) {

  await updateDoc(

    doc(
      db,
      "couponCodes",
      id,
    ),

    {

      ...data,

      updatedAt:
        serverTimestamp(),

    }

  );

}

/* ==========================================
    DELETE COUPON
========================================== */

export async function deleteCoupon(id) {

  await deleteDoc(

    doc(
      db,
      "couponCodes",
      id,
    )

  );

}